import React from 'react';
import { Check } from 'lucide-react';
import AnimatedSection from '../../components/AnimatedSection/AnimatedSection';
import PageHeader from '../../components/PageHeader/PageHeader';
import './Plans.css';

export default function Plans() {
  const plans = [
    { name: 'Domestic Plan', price: '30', storage: '200GB', bw: '3GB' },
    { name: 'Global Plan', price: '50', storage: '250GB', bw: '3GB', popular: true },
    { name: 'Enterprise Plan', price: '100', storage: '500GB', bw: '3GB' },
    { name: 'Unlimited Plan', price: '120', storage: '500GB', bw: '5GB' },
  ];

  return (
    <div className="plans-page">
      <PageHeader title="Plans" breadcrumb="HOME > PLANS" />

      <div className="plans-content container">
        <AnimatedSection>
          <p className="section-label">{"// CHOOSE YOUR PLAN"}</p>
          <h2 className="section-title">Flexible Pricing Plans</h2>
        </AnimatedSection>

        <div className="plans-grid">
          {plans.map((plan, idx) => (
            <AnimatedSection key={idx}>
              <div className={`plan-card ${plan.popular ? 'popular' : ''}`}>
                <div className="plan-header">
                  <h3>{plan.name}</h3>
                  <div className="price-box">
                    <span className="currency">R</span>
                    <span className="price">{plan.price}</span>
                  </div>
                  <p>Monthly Package</p>
                </div>
                <div className="plan-body">
                  <div className="plan-feature"><Check className="feature-icon" size={20} /> 24/7 Tech Support</div>
                  <div className="plan-feature"><Check className="feature-icon" size={20} /> Advanced Options</div>
                  <div className="plan-feature"><Check className="feature-icon" size={20} /> {plan.storage} Storage</div>
                  <div className="plan-feature"><Check className="feature-icon" size={20} /> {plan.bw} Bandwidth</div>
                  <button className="btn-plan">CHOOSE PACKAGE</button>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>

      <div className="consultation-banner">
        <AnimatedSection className="container">
          <p className="section-label">{"// Drop us a line! We are here to answer your questions 24/7"}</p>
          <h2>NEED A CONSULTATION?</h2>
          <button className="btn-primary">Contact Us Now</button>
        </AnimatedSection>
      </div>
    </div>
  );
}